export default __webpack_public_path__ + "static/webtap-360d6cdfcbd5e59c12538325929fd684.webp";